import { dataUserSync } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSync = /*#__PURE__*/createIcon(dataUserSync)
export default IconUserSync
